import DIApi from './_diApi';

class AccountCategoryAPI extends DIApi {
  controllerName = 'AccountCategorys';
}

export default new AccountCategoryAPI();
